import { render, staticRenderFns } from "./PostEditEditor.vue?vue&type=template&id=60d07f51&lang=pug"
import script from "./PostEditEditor.vue?vue&type=script&lang=js"
export * from "./PostEditEditor.vue?vue&type=script&lang=js"
import style0 from "./PostEditEditor.vue?vue&type=style&index=0&id=60d07f51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports